import { DefaultClass } from "../classes/DefaultClass";
import { utils } from "../utils";
import { EventEmitter } from "../../../../../shop/frontend/web/js/components/EventEmitter";
import { DatePickerComponent } from "../../../../../shop/frontend/web/js/components/DatePickerComponent";
import { EventFilter } from "../../../../../shop/frontend/web/js/components/EventFilter";
import { translator } from "../../../../../shop/frontend/web/js/services/TranslatorService";
import { EventFilterModel } from "../../../../../shop/frontend/web/js/models/EventFilterModel";

/**
 *  Класс для страницы афишы
 * @extends DefaultClass
 */
export class Index extends DefaultClass {
	constructor() {
		super();

		this.emitter = new EventEmitter();

		/* Объявляем переменные для фильтра */
		this.eventFilter = new EventFilter();
		this.filterModel = new EventFilterModel();

		/**
		 * Будет включать в себя компонент для работы с датой фильтра
		 * @module DatePickerComponent
		 */
		this.datePicker = null;

		this.$eventItems = $("#js-event-items");

		this.$filterClear = $("#js-filter-clear");
		this.$message = $("#js-events-message");
	}

	init() {
		utils.toTop($("#js-index"));
		translator.getLanguages().then(() => {
			this.initMainCalendar();

			this.setUpSubscribers();
			this.setUpListeners();
		});
	}

	setUpSubscribers() {
		this.emitter.subscribe("after-applied-filter", res => {
			if (res.eventsCount > 0) {
				this.$message.hide();
			} else {
				this.$message.text(translator.t("event", "No active events")).show();
			}

			/* если задействовали пагинацию то просто выводим снизу */
			if (parseInt(res.page) > 0) {
				this.$eventItems.append(res.html);
			} else {
				this.$eventItems.html(res.html);
			}

			this.eventFilter.renderLoadMoreBtn(res.eventsCount, 5);
		});

		this.emitter.subscribe("apply-filter", () => {
			this.filterModel.limit = $("#js-filter").data("limit");
			return this.filterModel
				.search(this.filterModel.getSearchParams())
				.then(res => this.emitter.emit("after-applied-filter", res));
		});

		this.emitter.subscribe("clear-filter", () => {
			this.$filterClear.removeClass("active");

			this.filterModel.page = 0;
			this.filterModel.dateRange = null;
			this.datePicker.clearDateRangeInputs();
			this.datePicker.reset();

			return this.emitter.emit("apply-filter", {});
		});
	}

	setUpListeners() {
		this.$filterClear.on("click", () => this.emitter.emit("clear-filter", {}));

		this.eventFilter.on("click-load-more", () => {
			this.filterModel.setNextPage();

			return this.emitter.emit("apply-filter");
		});
	}

	initMainCalendar() {
		this.datePicker = new DatePickerComponent($(".js-datepicker-filter"));
		this.datePicker.initDateRangeInputs();

		this.datePicker.on("apply", (ev, picker) => {
			const formatStart = picker.startDate.format("DD-MM-YYYY");
			const formatEnd = picker.endDate.format("DD-MM-YYYY");

			if (formatStart === formatEnd) {
				this.filterModel.dateRange = formatStart;
			} else {
				this.filterModel.dateRange = formatStart + " — " + formatEnd;
			}

			this.$filterClear.addClass("active");

			this.filterModel.page = 0;

			return this.emitter.emit("apply-filter");
		});

		this.datePicker.on("cancel", () => this.emitter.emit("clear-filter", {}));
	}
}

const index = new Index();
index.init();
